/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AttendanceRange } from './attendanceRange';

export interface ChildOverviewPreschool { 
    childUuid: string;
    firstName: string;
    lastName: string;
    readonly excusedCount: number;
    readonly absentCount: number;
    readonly dates: { [key: string]: Array<AttendanceRange>; };
    readonly datePeriod: AttendanceRange;
    readonly archived: boolean;
}